import Spinner from 'src/javascripts/components/utilities/Spinner';
import Swal from 'sweetalert2';
import {companiesBloodhound, filterTypeaheadNoCache} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import BuildApiUrl from 'src/javascripts/components/tables/BuildApiUrl';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default function() {

  // Set constants
  const accountUrl = $('body').attr('data-account-url');
  const queryId = $('#filtersModal').attr('data-query-id');
  const reloadUrl = window.location.pathname;
  let reloadTimeout = null;

  // Set function to reload page with params
  const reloadResearch = function(notice = "") {
    if (reloadTimeout) {
      clearTimeout(reloadTimeout);
    }

    reloadTimeout = window.setTimeout(() => {
      reloadTimeout = null;

      // Set params based on filter attributes
      let params = {};
      let data = $('#filtersModal').data();
      $.each(data, function(key, val) {
        if (val === '') { return; }
        if (key.indexOf('filter') !== -1) {
          let k = key.replace("filters", "")
          k = k.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
          k = k.slice(1);
          params[k] = val
        }
      });

      // Set param to auto-show modal
      params['as'] = 'true';

      // Set scroll position of filters
      let modalBody = $("#filtersModal").find('.modal-body');
      let scrollFilter = modalBody.scrollTop();
      params['sp'] = scrollFilter;

      // Reload with params
      Turbo.visit(reloadUrl + '?' + $.param(params));
    }, 0);

  }

  // Format display numbers in form
  NumberDisplay();

  // Init bloodhounds
  companiesBloodhound.initialize();

  // Update query name/description
  $('.save-query').off().click(function(e) {
    e.preventDefault();
    let nameVal = $('#reusableModelNameInput').val();
    let queryParams = new URLSearchParams(window.location.search)
    queryParams.delete('sp');
    queryParams.delete('query_id');
    queryParams.delete('issuer_type');
    let queryString = queryParams.toString();
    let queryType = $('.queries-filter').data('query-type');
    let params = {};
    params['query_id'] = queryId;
    params['query'] = {};
    params['query']['name'] = nameVal;
    params['query']['query_string'] = queryString;
    params['query']['query_type'] = queryType;
    let url = '/' + accountUrl + '/queries?' + $.param(params);
    if (nameVal === '') {
      ToastCustom({title: 'Name required', message: 'Please enter a name for the query', delay: 3000});
    } else {
      $.ajax({
        type: 'POST',
        url: url,
        dataType: 'application/json',
        complete(result) { 
          let resultStatus = JSON.parse(result.responseText);
          let queryId = resultStatus.query_id
          Turbo.visit(window.location.pathname + '?query_id=' + queryId + '&' + queryString);
        },
      })
    }
  });

  // Select and load an existing query
  $('.queries-filter').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
    ev.preventDefault();
    $('.tooltip').tooltip('hide');

    // Re-load with query string
    let reloadUrl = window.location.pathname;
    let queryString = 'as=true&query_id=' + suggestion.record_id + '&' + suggestion.query_string;

    // Reload
    $(this).blur();
    return Turbo.visit(reloadUrl + '?' + queryString);

  });

  // Init typeahead for queries
  let queriesUrl = '/' + accountUrl + '/queries?';
  let queriesParams = {};
  let queryType = $('.queries-filter').data('query-type');
  queriesParams['query_type'] = queryType;
  queriesUrl = queriesUrl + $.param(queriesParams);
  filterTypeaheadNoCache('.queries-filter', 'queries', queriesUrl, 492, 'generic');

  // On clear typeahead
  $('.clear-typeahead').click(function() {
    let t = $(this).closest('.form-group').find('.typeahead');
    t.typeahead('val', '');
    t.focus();
  })

  // On typeahead select, create a filter
  $('.research-filters-typeahead').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
    ev.preventDefault();
    $('.tooltip').tooltip('hide');

    // Set value
    let val;
    if (typeof suggestion.methodology_id !== 'undefined') {
      val = suggestion.methodology_id;
    } else if (typeof suggestion.record_id !== 'undefined') {
      val = suggestion.record_id;
    } else if (typeof suggestion.value !== 'undefined') {
      val = suggestion.value;
    } else {
      val = suggestion;
    }

    // Set record on filters modal
    let key = $(this).attr('data-key');

    if (key.indexOf('_') !== -1) {
      key = key.replace(/_/g, '-'); // Use dashes for data attributes: included_issuers -> included-issuers
    }

    let currentFilter = $('#filtersModal').data('filters-' + key);
    let lowerVal = val.toString().toLowerCase().replace(/\s+/g, '_');
    let updateMethod = $(this).attr('data-update-method');
    if ((typeof updateMethod !== 'undefined') && (updateMethod === 'add')) {
      if ($.isArray(currentFilter)) {

        // Check if in array already 
        if ( !currentFilter.includes(val) && (!currentFilter.includes(lowerVal)) ) {

          // Add filter
          currentFilter.push(val);

          // Filter out blank string
          currentFilter = currentFilter.filter(n => n);

          // Add attr to filter modal
          $('#filtersModal').data('filters-' + key, currentFilter);

        }

      } else if (typeof currentFilter !== 'undefined') {
        
        if ( (currentFilter.indexOf(val) === -1) && (currentFilter.indexOf(lowerVal) === -1) ) {
          $('#filtersModal').data('filters-' + key, [currentFilter, val]);
        }

      } else {
        $('#filtersModal').data('filters-' + key, [val]);

      }

    } else {
      $('#filtersModal').data('filters-' + key, val);
    }

    // Remove any params/keys specified
    // For example, if we want portfolio_id, fund_id, OR list_id
    let removeKeys = $(this).attr('data-remove-keys');
    if (typeof removeKeys !== 'undefined') {
      removeKeys = JSON.parse(removeKeys);
      $.each(removeKeys, function(k,v) {
        $('#filtersModal').removeData('filters-' + v);
      })
    }

    // Re-load with parameters
    reloadResearch();

    // Blur typeahead
    $(this).blur();

  });

  // On clicking save for a slider filter
  $('.SaveSliderFilter').off().click(function() {

    // Set value (range of expense ratio)
    let $inputGroup = $(this).closest('.input-group')
    let min = parseFloat($inputGroup.find('.slider-min').val());
    let max = parseFloat($inputGroup.find('.slider-max').val());
    let val = [min, max]
    let key = $(this).attr('data-key');

    // Set filters modal value
    $('#filtersModal').data('filters-' + key, val);

    // Re-load with parameters
    reloadResearch();

  })

  // Sliders on select
  if ($('.slider-mix-input').length !== 0) {
    $('.slider-mix-input').each(function(el) {
      $('.slider-mix-input').ionRangeSlider({
        type: "double",
        grid: false,
        step: 1,
        grid_num: 1,
        hide_min_max: true,
        onFinish(data) {
          let val = [data.from, data.to]
          let key = data.input.attr('data-key');

          // Set record on filters modal
          $('#filtersModal').data('filters-' + key, val);

          // Re-load with parameters
          reloadResearch();

        }
      });
    })
  }

  // On screens typeahead select, create a filter
  $('.screens-filter').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {
    ev.preventDefault();
    $('.tooltip').tooltip('hide');

    // Set attrs
    let currentFilter = $('#filtersModal').data('filters-screens');

    // Set record on filters modal
    if ($.isArray(currentFilter)) {
      currentFilter.push(suggestion.key, 0, 100);
      $('#filtersModal').data('filters-screens', currentFilter);

    } else {
      $('#filtersModal').data('filters-screens', [suggestion.key, 0, 100]);

    }

    // Re-load with parameters
    reloadResearch();

    // Blur typeahead
    $(this).blur();

  });

  // Sliders on select - screens
  if ($('.slider-screen-input').length !== 0) {
    $('.slider-screen-input').each(function(el) {
      $('.slider-screen-input').ionRangeSlider({
        type: "double",
        grid: false,
        step: 1,
        grid_num: 1,
        hide_min_max: true,
        onFinish(data) {
          data.input.attr('min', data.from);
          data.input.attr('max', data.to);
          let screensFilter = []
          let screenSliders = $('.slider-screen-input');
          $.each(screenSliders, function(i,k) {
            let key = $(k).data('key');
            let min = $(k).data('from');
            let max = $(k).data('to');
            screensFilter.push(key, min, max);
          })

          // Set record on filters modal
          $('#filtersModal').data('filters-screens', screensFilter);

          // Re-load with parameters
          reloadResearch();

        }
      });
    })
  }

  // Radio buttons on change, only within filters modal
  $('#filtersModal .custom-control-input').on('change', function(ev, suggestion) {
    let key = $(this).attr('data-key');
    let val = $(this).val();
    if ($(this).is(':checkbox')) {
      val = $(this).is(':checked') ? 'true' : 'false';
    }
    $('#filtersModal').data('filters-' + key, val);
    reloadResearch();
  })

  // Date field buttons on change, only within filters modal
  $('#filtersModal input[type="date"]').on('change', function(ev, suggestion) {
    let val = $(this).val();
    let key = $(this).attr('data-key');
    $('#filtersModal').data('filters-' + key, val);
    reloadResearch();
  })

  // Remove opaque class to show sliders (starts as opaque to hide occasional jumping while JS initiating above)
  $('.slider-mix-body').removeClass('opaque');

  // Tear down sliders before cache
  $(document).on("turbo:before-cache", function() {
    $('.slider-mix-input').each(function(el) {
      let data = $(el).data('ionRangeSlider');
      if (data !== null && typeof data !== 'undefined') { data.destroy(); }
    });
    $('.spinner-container').remove();
    $('.card-body').css('opacity', 1);
    $('.disabled').removeClass('disabled');
  });
 
}
